import {get} from "lodash";
import AppSettingController from "../../../Main/controller/AppSettingController";
import MarketSettingLocalStorage from "../../../Main/interface/MarketSettingLocalStorage";
import React from "react";
import PrintItem from "./PrintItem";
import {useTranslation} from "react-i18next";

export default function PrinterList() {
    const {t} = useTranslation();
    const setting = AppSettingController.getSetting() as MarketSettingLocalStorage;


    return (
        <div className="discount-cods-list-container">
            <div className="desk-list">
                <div className={'desk-list-header'}>
                    <h3>{t("setting.printerList")}</h3>
                </div>
                <div className="desk-list-item">
                    {get(setting, "printer", []).map((item: {
                        id: string,
                        ip: string,
                        port: number,
                        name: string,
                    }) => (
                        <PrintItem printer={item} key={item.id}/>
                    ))}
                </div>
            </div>
        </div>
    );
}